import fetch from '@/utils/fetch'

export function getNewTeamList () {
  return fetch({
    url: '/get_new_team_list',
    params: {
    },
    method: 'get'
  })
}

export function delTeam (data) {
  return fetch({
    url: '/del_team_by_guid',
    data,
    method: 'post'
  })
}

export function closeTeam (data) {
  return fetch({
    url: '/close_team_by_guid',
    data,
    method: 'post'
  })
}

export function openTeam (data) {
  return fetch({
    url: '/open_team_by_guid',
    data,
    method: 'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/api_team.js